import {
    Getter,
    ComputedGetters,
} from '@app/store/StoreUtil';
import OfferEvent from '@core/models/offer/OfferEvent';

import {
    GamingUserPreferencesState,
    GamingGetters,
    GamingUserPreferencesStateLegacy,
} from './gaming/types';

type DEFAULT_USER_ID = 'defaultUserId';
export const DEFAULT_USER_ID: DEFAULT_USER_ID = 'defaultUserId';

export interface IFavouriteTournament {
    displayName: string;
    id: number;
}

export type PredefinedStake = {
    value: number,
    index: number,
};

export type BetslipPreferences = {
    shouldDeleteBetslipAfterPurchase: boolean,
    predefinedStakes: PredefinedStake[],
};

export interface IUserPreferences extends GamingUserPreferencesState {
    version: string;
    favouriteTournaments: number[];
    favouriteMarkets: string[];
    pinnedEvents: number[];
    betslipPreferences: BetslipPreferences;
}
interface IUserPreferencesLegacy extends GamingUserPreferencesStateLegacy {
    version: string;
    favouriteTournaments: number[];
    favouriteMarkets: number[];
    pinnedEvents: number[];
    betslipPreferences: BetslipPreferences;
}

export type IPreferencesState = Record<string, IUserPreferences>;
export type IPreferencesStateLegacy = Record<string, IUserPreferencesLegacy>; // only found in localStorage, saved by vuex persisted state

export type PreferencesGetter<T> = Getter<IPreferencesState, PreferencesGetters, T>;

export interface Getters extends GamingGetters {
    tournaments: PreferencesGetter<IFavouriteTournament[]>;
    tournamentsEvents: PreferencesGetter<OfferEvent[]>;
    tournamentIds: PreferencesGetter<number[]>;
    _userState: PreferencesGetter<IUserPreferences>;
    marketIds: PreferencesGetter<string[]>;
    _userId: PreferencesGetter<number | DEFAULT_USER_ID>;
    pinnedEventIds: PreferencesGetter<number[]>;
    pinnedEvents: PreferencesGetter<OfferEvent[]>;
    deleteBetslipAfterPurchase: PreferencesGetter<boolean>;
    predefinedStakes: PreferencesGetter<PredefinedStake[]>;
    [key: string]: PreferencesGetter<any>; // to satisfy vuex typings
}

export type PreferencesGetters = ComputedGetters<Getters>;
